export class UserLogin
{
	userName:string;
	password:string;
	idleTime:number
}
